export const firstStreak = [
  '本規約は，ユーザーと当社との間の本サービスの利用に関わる一切の関係に適用されるものとします。',
  '当社は本サービスに関し，本規約のほか，ご利用にあたってのルール等，各種の定め（以下，「個別規定」といいます。）をすることがあります。これら個別規定はその名称のいかんに関わらず，本規約の一部を構成するものとします。',
  '本規約の規定が前条の個別規定の規定と矛盾する場合には，個別規定において特段の定めなき限り，個別規定の規定が優先されるものとします。',
];

export const secondStreak = [
  '本サービスにおいては，登録希望者が本規約に同意の上，当社の定める方法によって利用登録を申請し，当社がこの承認を登録希望者に通知することによって，利用登録が完了するものとします。',
  '当社は，利用登録の申請者に以下の事由があると判断した場合，利用登録の申請を承認しないことがあり，その理由については一切の開示義務を負わないものとします。',
];

export const secondStreakDescription = [
  '利用登録の申請に際して虚偽の事項を届け出た場合',
  '本規約に違反したことがある者からの申請である場合',
  'その他，当社が利用登録を相当でないと判断した場合',
];

export const thirdStreak = [
  'ユーザーは，自己の責任において，本サービスのユーザーIDおよびパスワードを適切に管理するものとします。',
  'ユーザーは，いかなる場合にも，ユーザーIDおよびパスワードを第三者に譲渡または貸与し，もしくは第三者と共用することはできません。当社は，ユーザーIDとパスワードの組み合わせが登録情報と一致してログインされた場合には，そのユーザーIDを登録しているユーザー自身による利用とみなします。',
  'ユーザーID及びパスワードが第三者によって使用されたことによって生じた損害は，当社に故意又は重大な過失がある場合を除き，当社は一切の責任を負わないものとします。',
];

export const fourthStreak = [
  '法令または公序良俗に違反する行為',
  '犯罪行為に関連する行為',
  '当社，本サービスの他のユーザー，または第三者のサーバーまたはネットワークの機能を破壊したり，妨害したりする行為',
  '当社のサービスの運営を妨害するおそれのある行為',
  '他のユーザーに関する個人情報等を収集または蓄積する行為',
  '不正アクセスをし，またはこれを試みる行為',
  '他のユーザーに成りすます行為',
  '当社のサービスに関連して，反社会的勢力に対して直接または間接に利益を供与する行為',
  '当社，本サービスの他のユーザーまたは第三者の知的財産権，肖像権，プライバシー，名誉その他の権利または利益を侵害する行為',
  '宗教活動または宗教団体への勧誘行為',
  'その他，当社が不適切と判断する行為',
];
